/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React from 'react'
import { Container, Card } from './styles'
import { IconComponent } from '~/assets/icons/component'
import { HealthProcedureVariantProps } from '~/constants'
import { HealthProceduresTypes } from '~/interfaces'

interface ModalItemListProceduresProps {
  type: HealthProceduresTypes
  onClick: () => void
  label?: string
  value?: string | number
}

export const ModalItemListProcedures = ({ type, onClick, label, value }: ModalItemListProceduresProps): JSX.Element => {
  const modalItemVariant = HealthProcedureVariantProps[type]
  return (
    <Container data-testid={`item-list-procedures-${type}`}>
      <Card data-testid={label} color={modalItemVariant?.color} onClick={onClick}>
        <div data-testid="svg" className="icon">
          <IconComponent name={modalItemVariant?.iconName} />
        </div>
        <div className="infos">
          <span data-testid={'span'}>
            {label || 'Não Informado'} - {value || 'Não Informado'}
          </span>
        </div>
      </Card>
    </Container>
  )
}
